import React from "react";
import BusinessTabs from "./BusinessTabs";
import CheckPoint from "./CheckPoint";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const FeatureB = () => {
    const settings = {
        dots: true,
        autoplay: false,
        Speed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        arrows: false
    };

    return (
        <>
            <BusinessTabs current="ICT" />

            <section className="bg-gray-50">
                <div className="container mx-auto max-w-6xl space-y-section px-5 py-section-lg xl:px-0">
                    {/* <div>
                        <h2 className="text-center   text-2xl  font-bold tracking-tight text-brand  sm:text-4xl">
                            ICT융합기술R&D / 기술사업화
                        </h2>
                        <p className="mx-auto mt-4 text-center text-base text-gray-400">
                            &quot; 지속적으로 다양한 산업 분야와 접목될 수 있는
                            ICT기반 융합기술을 R&D하고 있습니다&quot;
                        </p>
                    </div> */}

                    <div
                        className="grid lg:grid-cols-2 lg:items-center lg:gap-8"
                        id="1"
                    >
                        <div>
                            <h3 className="text-h2 font-bold dark:text-gray-50">
                                ICT융합기술R&D
                            </h3>
                            <div className="mt-8 space-y-12">
                                <CheckPoint
                                    title="다양한 산업 분야"
                                    description="지속적으로 다양한 산업 분야와 접목될 수 있는 ICT기반 융합기술을 R&D하고 있습니다."
                                />
                                <CheckPoint
                                    title="글로벌 기업"
                                    description="글로벌 기업들과 60여개의 ICT융합기술R&D 프로젝트를 수행하였습니다."
                                />
                                <CheckPoint
                                    title="온오프라인 융합 시스템 및 서비스의 컨설팅"
                                    description="R&D 기술력과 조직력을 기반으로 온오프라인 융합 시스템 및 서비스의 컨설팅 업무를 수행하고 있습니다."
                                />
                            </div>
                        </div>
                        <div
                            aria-hidden="true"
                            className="img_slide_wrap mt-10 overflow-hidden rounded-lg lg:mt-0"
                        >
                            <Slider {...settings}>
                                <img
                                    src="/img/img_sub2-1.png"
                                    alt=""
                                    className="mx-auto "
                                />

                                <img
                                    src="/img/img_sub2-3.png"
                                    alt=""
                                    className="mx-auto "
                                />
                            </Slider>
                        </div>
                    </div>
                    <div
                        className="grid lg:grid-cols-2 lg:items-center lg:gap-8"
                        id="2"
                    >
                        <div className="lg:col-start-2">
                            <h3 className="text-h2 font-bold dark:text-gray-50">
                                ICT 융합기술 사업화
                            </h3>
                            <div className="mt-8 space-y-8">
                                <CheckPoint
                                    title="기술사업화(Technology Commercialization)"
                                    description="케이유융합소프트웨어연구센터는 대학원천기술을 상용화할 수 있는 ICT융합 사업을 기획하며, 기술의 발굴, 확보, 이전, 상용화 개발, 마케팅, 투자유치의 전단계 프로세스를 수행합니다. 이를 기술사업화(Technology Commercialization)라고 합니다."
                                />
                                <CheckPoint
                                    title="기술 이전 사업화 및 인큐베이팅"
                                    description="케이유융합소프트웨어연구센터는 기존 전통산업과 ICT융합을 통해 부가가치를 창출할 수 있는 사업아이템을 발굴하여, 기술 이전 사업화 및 인큐베이팅을 진행하고 있습니다."
                                />
                            </div>
                        </div>
                        <div className="img_slide_wrap mt-10 overflow-hidden rounded-lg lg:col-start-1 lg:row-start-1 lg:mt-0">
                            <Slider {...settings}>
                                <img
                                    src="/img/img_sub2-4.png"
                                    alt=""
                                    className="mx-auto "
                                />
                                <img
                                    src="/img/img_sub2-5.png"
                                    alt=""
                                    className="mx-auto "
                                />
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FeatureB;
